import Header from "./Header";
import "../App.css";
import { useState, useEffect } from "react";

import fire from "./Firebase";
import { v4 } from "uuid";
import Footer from "../Footer";

function Allpicture() {
  document.title='HR School - All Picture'
  var [inputsda, setinputsda] = useState();
  var [storedatafromfirebase, setstoredatafromfirebase] = useState({});

  useEffect(() => {
    fire.child("data").on("value", (snapt) => {
      if (snapt.val() == null || snapt.val() == "") alert("Data Fetch");
      else setstoredatafromfirebase(snapt.val());
      // setstoredatafromfirebase(snapt.val());
    });
  }, []);
  return (
    <div>
      <Header />
      <div>
        {Object.keys(storedatafromfirebase).map((snapt, index) => {
          return (
            <>
              <div id="newbox">
                <img
                  src={storedatafromfirebase[snapt].img}
                  alt=""
                  style={{
                    height: "370px",
                    width: "100%",
                    borderRadius: "10%",
                  }}
                  id="imgs"
                />
              </div>
            </>
          );
        })}
      </div>
      <br />
      <br />

    </div>
  );
}
export default Allpicture;
